export default Object.freeze({
  EFFECTIVE_DATE: {
    HEADER: 'Effective Date',
    ACCESSOR: 'Effective Date'
  },
  ACCRUAL_RATE: {
    HEADER: 'Accrual Rate',
    ACCESSOR: 'accrualRate'
  },
  DATE_ACCRUAL_BEGINS: {
    HEADER: 'Date Accrual Begins',
    ACCESSOR: 'dateAccrualBegins'
  }
})
